module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dictionary-wrap"
  }, [(_vm.isPc) ? _c('div', [_c('div', {
    staticClass: "dictionary-header"
  }, [_c('div', {
    staticClass: "dictionary-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputWord),
      expression: "inputWord"
    }],
    attrs: {
      "type": "text",
      "placeholder": "調べたい英単語を入力"
    },
    domProps: {
      "value": (_vm.inputWord)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.doSearch()
      }
    }
  }, [_c('span', {
    staticClass: "icon-search"
  }), _vm._v("検索")])]), _vm._v(" "), _c('div', {
    staticClass: "dictionary-word"
  }, _vm._l((_vm.wordList), function(word, index) {
    return _c('div', {
      staticClass: "search-word",
      on: {
        "click": function($event) {
          return _vm.getDictionary(word, index)
        }
      }
    }, [_c('a', {
      class: {
        search_word_active: index == _vm.currentWordIndex
      }
    }, [_vm._v(_vm._s(word))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dictionary-main"
  }, [_c('div', {
    staticClass: "dictionary-result-sub"
  }, [_c('div', {
    staticClass: "dictionary-use"
  }, [(_vm.currentWord.length != 0) ? _c('p', {
    staticClass: "dictionary-title"
  }, [_vm._v(_vm._s(_vm.currentWord) + "を使った表現")]) : _vm._e(), _vm._v(" "), (_vm.entryWordResponseJson == null) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.entryWordError))])]) : _c('div', _vm._l((_vm.setPhraseList), function(setPhrase, index) {
    return _c('div', {
      staticClass: "dictionary-list",
      on: {
        "click": function($event) {
          return _vm.showSetPhraseResult(index)
        }
      }
    }, _vm._l((setPhrase.linesData), function(linesData) {
      return _c('div', _vm._l((linesData), function(lines) {
        return _c('div', [_c('a', {
          class: {
            dictionary_include_text_active: _vm.currentSetPhraseIndex == index
          },
          domProps: {
            "innerHTML": _vm._s(_vm.changeTag(lines.text))
          }
        })])
      }), 0)
    }), 0)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dictionary-include"
  }, [(_vm.currentWord.length != 0) ? _c('p', {
    staticClass: "dictionary-title"
  }, [_vm._v(_vm._s(_vm.currentWord) + "を含む表現")]) : _vm._e(), _vm._v(" "), (_vm.phraseResponseJson == null) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.phraseError))])]) : _c('div', _vm._l((_vm.phraseResponseJson), function(phrase, index) {
    return _c('div', {
      staticClass: "dictionary-list",
      on: {
        "click": function($event) {
          return _vm.showPhraseResult(index)
        }
      }
    }, [_c('a', {
      class: {
        dictionary_include_text_active: _vm.currentPhraseIndex == index
      },
      domProps: {
        "innerHTML": _vm._s(_vm.changeTag(phrase.text))
      }
    })])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "dictionary-result-main"
  }, [(_vm.phraseResult == null) ? _c('div', {
    staticClass: "dictionary-result-main-inner"
  }, [(_vm.entryWordResponseJson == null) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.entryWordError))])]) : (_vm.setPhraseResult == null) ? _c('div', [_c('WordResult', {
    attrs: {
      "dataList": _vm.wordResultList
    }
  })], 1) : _c('div', [_c('SetPhraseResult', {
    attrs: {
      "data": _vm.setPhraseResult
    }
  })], 1)]) : _c('div', {
    staticClass: "area-phraseresult"
  }, [_c('div', {
    staticClass: "dictionary-result-main-inner"
  }, [_c('PhraseResult', {
    attrs: {
      "data": _vm.phraseResult
    }
  })], 1)])])])]) : _c('div', {
    staticClass: "dictionary flexcenter",
    class: {
      'dictionary-modal': _vm.isModal
    }
  }, [_c('transition', [_c('div', {
    staticClass: "dictionary-dialog"
  }, [(_vm.isModal) ? _c('button', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.closeDictionary()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dictionary-dialog-inner"
  }, [_c('div', {
    staticClass: "dictionary-header flexbetween"
  }, [(_vm.showSearchWord) ? _c('div', [_c('div', {
    staticClass: "dictionary-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputWord),
      expression: "inputWord"
    }],
    attrs: {
      "type": "text",
      "placeholder": "調べたい英単語を入力"
    },
    domProps: {
      "value": (_vm.inputWord)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputWord = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button-cancel",
    on: {
      "click": function($event) {
        return _vm.doCancel()
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), (!_vm.isModal) ? _c('div', {
    staticClass: "dictionary-close",
    on: {
      "click": function($event) {
        return _vm.closeDictionary()
      }
    }
  }) : _vm._e()])]) : _c('div', {
    staticClass: "dictionary-word"
  }, [_c('div', {
    staticClass: "search-word-wrap"
  }, _vm._l((_vm.wordList), function(word, index) {
    return _c('div', {
      staticClass: "search-word",
      on: {
        "click": function($event) {
          return _vm.getDictionary(word, index)
        }
      }
    }, [_c('a', {
      class: {
        search_word_active: index == _vm.currentWordIndex
      }
    }, [_vm._v(_vm._s(word))])])
  }), 0), _vm._v(" "), _c('button', {
    staticClass: "button-search-s",
    on: {
      "click": function($event) {
        return _vm.doShowSearchWord()
      }
    }
  }, [_c('span', {
    staticClass: "icon-search"
  })]), _vm._v(" "), (!_vm.isModal) ? _c('div', {
    staticClass: "dictionary-close",
    on: {
      "click": function($event) {
        return _vm.closeDictionary()
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "dictionary-main"
  }, [_c('div', {
    staticClass: "dictionary-main-inner"
  }, [_c('div', {
    staticClass: "swiper-dictionary swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [(_vm.entryWordResponseJson == null) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.entryWordError))])]) : _c('div', [_c('WordResult', {
    attrs: {
      "dataList": _vm.wordResultList
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [(_vm.currentWord.length != 0) ? _c('p', {
    staticClass: "bold mb10 font-large"
  }, [_vm._v(_vm._s(_vm.currentWord) + "を使った表現")]) : _vm._e(), _vm._v(" "), (_vm.entryWordResponseJson == null) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.entryWordError))])]) : _c('div', [_vm._l((_vm.setPhraseList), function(setPhrase) {
    return [_c('SetPhraseResult', {
      attrs: {
        "data": setPhrase
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide"
  }, [(_vm.currentWord.length != 0) ? _c('p', {
    staticClass: "bold mb10 font-large"
  }, [_vm._v(_vm._s(_vm.currentWord) + "を含む表現")]) : _vm._e(), _vm._v(" "), (_vm.phraseResponseJson == null) ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.phraseError))])]) : _c('div', [_vm._l((_vm.phraseResponseJson), function(phrase) {
    return [_c('PhraseResult', {
      attrs: {
        "data": phrase
      }
    })]
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClickSearch),
      expression: "isClickSearch"
    }],
    staticClass: "swiper-pagination"
  })])])])], 1), _vm._v(" "), (_vm.showErrorDialog) ? _c('ErrorDialog', {
    attrs: {
      "message": _vm.errorMessage,
      "buttonKind": _vm.errorButtonKind,
      "platformName": _vm.platformName,
      "routeQuery": {
        showDictionary: true
      }
    },
    on: {
      "close": function($event) {
        _vm.showErrorDialog = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43d3f432", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-43d3f432","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dictionary/Dictionary.vue
// module id = 715
// module chunks = 1